import type { IconName } from '../components/ui.js';

/** Prostředí hubu: jeden zdroj pravdy pro názvy, popisy, ikony a barvy (tokeny --env-* v shell.css). */
export type EnvName = 'development' | 'staging' | 'production';

export const ENV_ORDER: readonly EnvName[] = ['development', 'staging', 'production'];

export const ENV_META: Record<
  EnvName,
  { label: string; short: string; icon: IconName; summary: string; details: string[] }
> = {
  development: {
    label: 'Vývoj',
    short: 'simulované hodiny, nic se neodesílá',
    icon: 'flask',
    summary: 'Hřiště na zkoušení. Čas je simulovaný a žádná zpráva neodejde ven.',
    details: [
      'Demo data a simulátor, kterým lze „přetočit čas“.',
      'Nic se neodesílá; SmartEmailing se jen čte.',
    ],
  },
  staging: {
    label: 'Zkouška',
    short: 'skutečné hodiny, jen na zkušební adresy',
    icon: 'layers',
    summary: 'Generálka před ostrým provozem. Zprávy odcházejí, ale jen na zkušební adresy.',
    details: [
      'Skutečné hodiny a skutečné odeslání přes SmartEmailing.',
      'Odchází jen na adresy z povoleného seznamu (TEST_ALLOWLIST).',
    ],
  },
  production: {
    label: 'Produkce',
    short: 'ostrý provoz, zprávy dostávají zákazníci',
    icon: 'bolt',
    summary: 'Ostrý provoz. Zprávy odcházejí skutečným zákazníkům.',
    details: ['Skutečná data a skutečné odesílání.', 'Zkušební nástroje (simulátor) jsou vypnuté.'],
  },
};

/** Bez zapnutého přepínání prostředí vychází štítek z `appEnv` nasazení. */
export function envFromApp(appEnv: string): EnvName {
  return appEnv === 'production' ? 'production' : 'development';
}
